import { ActivityWorkflowState, UIWorkflowState } from "PFTypes";

export const mapWorkflowStatesToUI = (workflowState: ActivityWorkflowState): UIWorkflowState => {
  if (workflowState === "shortlisting") {
    return "not_filled";
  }

  if (["auto_shortlisting", "auto_filling"].includes(workflowState)) {
    return "pending";
  }

  return workflowState as UIWorkflowState;
};
